import { useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaEdit, FaTrash } from 'react-icons/fa';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../../../../redux/store';
import { Btn } from '../../../../data/Btn';
import LayoutTable from '../../../../data/LayoutTable';
import tableStyleDefault from '../../../../../Services/tableStyleDefault';
import CustomLoader from '../../../../data/customLoader';
import ActiveInactiv from '../../../../data/activeInactive';
import ModalBootstrap from '../../../../data/Modal';
import { notify, notifyError } from '../../../../notify/notify-component';
import { IPaymentMechanisms } from '../../../../../redux/features/PaymentTypePDV/interface';
import {
  deletePAymentTypePDVAsync,
  getPAymentTypePDVAsync,
} from '../../../../../redux/features/PaymentTypePDV/services';

export default function Pdv({
  onEditItem,
  OnAddNewChartAccount,
  setKeyActived,
}: any) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const dispatch = useDispatch<AppDispatch>();
  const { paymentTypeDdv, paymentMechanisms, loading } = useAppSelector(
    ({ paymentTypePDVReducer }) => paymentTypePDVReducer.value,
  );

  const [modalConfirmation, setModalConfirmation] = useState<boolean>(false);
  const [uuid, setUuid] = useState<string>('');

  const handleEdit = (item: any) => {
    onEditItem(item);
  };

  const getMechanismLabel = (id: number) =>
    paymentMechanisms.find((item: IPaymentMechanisms) => item.id === id)
      ?.descricao ?? '---';

  const handleDelete = async (uuid: string) => {
    dispatch(deletePAymentTypePDVAsync(uuid)).then((result: any) => {
      if (deletePAymentTypePDVAsync.fulfilled.match(result)) {
        notify('Forma de recebimento excluída com sucesso.');
        dispatch(getPAymentTypePDVAsync(storeMe?.storeActive?.id));
      } else {
        notifyError('Erro ao excluir forma de recebimento.');
      }
    });
  };

  const handleModalUuid = (uuid: string) => {
    setUuid(uuid);
    setModalConfirmation(true);
  };

  const handleDeleteItem = () => {
    setModalConfirmation(false);
    handleDelete(uuid);
  };

  const columns: any = [
    {
      name: 'Código',
      width: '88px',
      center: true,
      selector: (row: any) => row?.code ?? '---',
    },
    {
      name: 'Descrição',
      minWidth: '190px',
      selector: (row: any) => <strong>{row?.description ?? '---'}</strong>,
    },
    {
      name: 'Tipo',
      center: true,
      selector: (row: any) => getMechanismLabel(row?.payment_mechanism_id),
    },
    {
      name: 'Status',
      width: '100px',
      center: true,
      selector: (row: any) => (
        <ActiveInactiv
          status={!row?.inactive}
          text={!row?.inactive ? 'Ativo' : 'Inativo'}
        />
      ),
    },
    {
      name: 'Ações',
      width: '100px',
      center: true,
      cell: (row: any) => (
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
          <button
            onClick={() => handleEdit(row)}
            title="Editar"
            style={{
              padding: '0.375rem',
              border: 'none',
              background: 'transparent',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <FaEdit size={16} color="#6c757d" />
          </button>
          <button
            onClick={() => handleModalUuid(row.uuid)}
            title="Excluir"
            style={{
              padding: '0.375rem',
              border: 'none',
              background: 'transparent',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <FaTrash size={14} color="#dc3545" />
          </button>
        </div>
      ),
      button: true,
    },
  ];

  return (
    <>
      <ModalBootstrap
        state={modalConfirmation}
        setState={setModalConfirmation}
        text="Tem certeza que deseja excluir esta forma de recebimento?"
        handleAction={handleDeleteItem}
      />

      <div className="mb-2 mt-4">
        <Btn
          text="Novo recebimento PDV"
          type="button"
          variante="primary"
          icon="plus"
          onClick={() => OnAddNewChartAccount(true)}
        />
      </div>

      <LayoutTable>
        <DataTable
          columns={columns}
          data={paymentTypeDdv ?? []}
          striped
          customStyles={tableStyleDefault}
          progressPending={loading}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>
    </>
  );
}
